import { Box, Center, Flex, Image, Progress, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const ReadingCard = ({ reading, url, progress, goalLabel }) => (
  <Link
    state={{ reading }}
    to={reading?.bookClubId ? "/community/book-club" : url}
  >
    <Box bg="gray.700" borderRadius="lg" overflow="hidden" mb="4">
      <Flex>
        <Image
          src={reading.readingOrder.thumbnail}
          alt={reading.readingOrder.title}
          height="72px"
        />
        <Center width="100%">
          <Box width="100%" px="6">
            <Text fontWeight="bold">{reading.readingOrder.title}</Text>
            <Text fontSize="small">
              {!!reading.readingOrder.years &&
                `${reading.readingOrder.years} • `}
              {reading.readingOrder.comicsCount} comics
            </Text>
            {!!goalLabel && (
              <Text fontSize="xs" color="gray.300" mt="1">
                {goalLabel}
              </Text>
            )}
          </Box>
        </Center>
        <Center p="6">
          <Text fontSize="small" color="red.200">
            {progress.toFixed(2)}%
          </Text>
        </Center>
      </Flex>
      <Progress size="sm" height="3px" value={progress} />
    </Box>
  </Link>
);

export default ReadingCard;
